export function populateTemplate(questions, template, values, type) {
  if (!template || ['welcome', 'cbswelcome'].includes(type.toLowerCase()))
    return ''

  let re = /\{\{(.+?)\}\}/gim
  let output = template

  try {
    let t = [...template.matchAll(re)]

    t.forEach(item => {
      output = output.replaceAll(
        item[0],
        values[item[1]] ||
          values[
            questions.find(question => question?.resource_id === item[1])?.id
          ]
      )
    })
  } catch (_) {}

  return output
}
